import type { $AppContainer } from './AppContainer.js';

import { createContext } from 'react';

export const AppContext = createContext<$AppContainer>(undefined!);
